export default "__VITE_PUBLIC_ASSET__4380d7d4__"